import React from 'react';

export default function FileUploader({
  label,
  maxFileSize,
  setFiles,
  multiple,
  accept,
}) {
  const updateFiles = (files) => {
    setFiles((prevFiles) => {
      const prevFilesArray = Array.from(prevFiles);

      const newFilesArray = Array.from(files);

      const allFiles = [...prevFilesArray, ...newFilesArray];

      // Remove duplicates
      const uniqueFilesMap = new Map();
      allFiles.forEach((file) => {
        const key = `${file.name}-${file.size}`;
        if (!uniqueFilesMap.has(key)) {
          uniqueFilesMap.set(key, file);
        }
      });

      return Array.from(uniqueFilesMap.values());
    });
  };

  const handleFileDrop = (event) => {
    event.preventDefault();
    const files = event.dataTransfer.files;
    if (files.length > 0) {
      updateFiles(files);
    }
  };

  return (
    <div>
      <label
        htmlFor="dropzone-file"
        className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
      >
        {label}
      </label>
      <div className="flex justify-center items-center w-full">
        <label
          htmlFor="dropzone-file"
          className="flex flex-col justify-center items-center w-full h-64 bg-gray-50 rounded-lg border-2 border-gray-300 border-dashed cursor-pointer dark:hover:bg-bray-800 dark:bg-gray-700 hover:bg-gray-100 dark:border-gray-600 dark:hover:border-gray-500 dark:hover:bg-gray-600"
          onDrop={handleFileDrop}
          onDragOver={(event) => event.preventDefault()}
        >
          <div className="flex flex-col justify-center items-center pt-5 pb-6">
            <svg
              aria-hidden="true"
              className="mb-3 w-10 h-10 text-gray-400"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
              ></path>
            </svg>
            <p className="mb-2 text-sm text-gray-500 dark:text-gray-400">
              <span className="font-semibold">Click to upload</span> or drag and
              drop
            </p>
            {maxFileSize ? (
              <p className="mb-4 text-xs text-gray-500 dark:text-gray-400">
                Max. File Size: {maxFileSize}MB
              </p>
            ) : null}
          </div>
          <input
            id="dropzone-file"
            type="file"
            className="hidden"
            multiple={multiple}
            accept={accept}
            onChange={(event) => {
              updateFiles(event.target.files);
            }}
          />
        </label>
      </div>
    </div>
  );
}
